<template>
  <div class="ma-0 pa-0 box-container" style="width: 100%; height: 100%">
    <v-dialog v-model="addTechnicianDialog" max-width="500px">
      <div class="ma-0 pa-0 customscroll" style="width: 100%; height: 370px">
        <v-card class="ma-0 pa-0">
          <v-card-title>
            <v-row class="ma-0 pa-0" justify="center">
              <span class="subtitle-1">{{ formTitle }}</span>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-form ref="refValidationForm" lazy-validation>
              <v-container v-if="technician">
                <v-text-field maxLength="26" :rules="global_rules.required" v-model="technician.n" :label="TR.Name"></v-text-field>
                <v-text-field maxLength="14" :rules="global_rules.required" v-model="technician.p" :label="TR.Phone"></v-text-field>
                <v-text-field maxLength="30" v-model="technician.c" :label="TR.Comment"></v-text-field>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <t-button :class="'ma-1'" :btnText="TR.Cancel" btnIcon="mdi-minus-circle" style="width: 150px" @click.native="close()" />
            <t-button :class="'ma-1'" :btnText="TR.Save" btnIcon="mdi-checkbox-marked-circle-outline" style="width: 150px" @click.native="save()" />
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
    <div class="row-header">
      <v-row v-if="error_message" align="center" justify="center" class="ma-0 pa-0">
        <v-alert justify="center" align="center" :value="true" color="default">{{ error_message }}</v-alert>
      </v-row>
      <v-row v-else align="center" justify="center" class="ma-0 pa-0">
        <v-text-field v-model="search" :label="TR.Search" class="mx-4"></v-text-field>
        <v-divider class="mx-4" inset vertical></v-divider>
        <t-button
          class="mb-2"
          @click.native="
            editIndex = -1;
            addTechnicianDialog = true;
          "
          :btnText="TR.Add"
          :btnIcon="'mdi-plus-circle'"
        ></t-button>
        <v-spacer></v-spacer>
      </v-row>
    </div>
    <div v-if="!error_message" class="row-content ma-0 pa-0" ref="refGridContainer">
      <v-data-table
        ref="refGridTechs"
        :height="gridHeight"
        :fixed-header="true"
        :headers="headers"
        :items="technicians"
        :class="isOnMobile ? 'elevation-1 ma-0 pa-0' : 'elevation-1 ma-2 pa-0'"
        :search="search"
        :custom-filter="filterSearch"
        :disable-pagination="true"
        :hide-default-footer="true"
      >
        <template v-slot:no-results
          ><span>{{ TR.NoRecordsFound }}</span></template
        >
        <template v-slot:[`item.devCount`]="{ item }">
          <span>{{ getDevsCount(item) }}</span>
        </template>
        <template v-slot:[`item.devBlockedCount`]="{ item }">
          <span>{{ getDevsBlockedCount(item) }}</span>
        </template>
        <template v-slot:[`item.devices`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon @click="addDevices(item)"> mdi-deskphone </v-icon>
              </v-btn>
            </template>
            <span>{{ TR.ChooseDevicesForTechnician }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-row align="center" justify="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)"> mdi-pencil </v-icon>
                </v-btn>
              </template>
              <span>{{ TR.EditTechnician }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
                </v-btn>
              </template>
              <span>{{ TR.DeleteTechnician }}</span>
            </v-tooltip>
          </v-row>
        </template>
        <template v-slot:no-data>
          <span class="subtitle-1">{{ TR.NoTechniciansAddes }}</span>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import DataManager, { ErrorMessage, DataHeader, DataPropType } from "../../js/DataManager";
import Translation from "../../js/Translation";
import { g_Dialog, TR } from "../../main";
export default {
  data() {
    return {
      gridHeight: 500,
      error_message: null,
      search: "",
      user: null,
      addTechnicianDialog: false,
      headers: [
        new DataHeader(TR.Name, "n", DataPropType.String),
        new DataHeader(TR.Phone, "p", DataPropType.String),
        new DataHeader(TR.Comment, "co", DataPropType.String),
        new DataHeader(TR.TotalDevs, "devCount", DataPropType.Number),
        new DataHeader(TR.BlockedDevs, "devBlockedCount", DataPropType.Number),
        { text: TR.ListDevs, value: "devices", align: "center", sortable: false, divider: true },
        { text: TR.Operations, value: "actions", align: "center", sortable: false, divider: true },
      ],
      reload: false,
      devs: [],
      technicians: [],
      editIndex: -1,
      technician: {
        name: "",
        phone: "",
        comment: "",
      },
      defaultInfo: {
        name: "",
        phone: "",
        comment: "",
      },
      onfocus: false,
      TR: TR,
    };
  },

  computed: {
    formTitle() {
      return this.editIndex === -1 ? TR.AddTechnician : TR.ChangeTechnician;
    },
  },
  methods: {
    setTitleAndData(meta, error) {
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.user = DataManager.getData(DataManager.DataType.user, true);
        this.devs = DataManager.getData(DataManager.DataType.devices, true);
        this.technicians = this.user.settings2.technicians;
        this.$nextTick(() => {
          this.recalcGridHeight();
        });
      } else {
        this.error_message = error.Message;
        this.dialogLoader.showError(error.Message, { location: "center" });
      }
    },
    getDevsCount(tech) {
      return this.devs.filter((d) => !this.reload && d.TechnicianId == this.technicians.indexOf(tech)).length;
    },
    getDevsBlockedCount(tech) {
      return this.devs.filter((d) => !this.reload && d.TechnicianId == this.technicians.indexOf(tech) && d.IsBlocked == true).length;
    },
    setFocus(on) {
      this.onfocus = on;
      if (on) this.recalcGridHeight();
    },
    recalcGridHeight() {
      setTimeout(() => {
        if (this.$refs && this.$refs.refGridContainer && this.$refs.refGridContainer.clientHeight > 0) {
          this.gridHeight = this.$refs.refGridContainer.clientHeight - (this.isOnMobile ? 0 : 30);
          //this.gridHeight = this.headersHeight + this.visibleRows * this.rowHeight + "px";

          // if (this.hasFooter) {
          //   this.visibleRows--; //footer
          // }
        }
      }, 500);
    },

    filterSearch(value, search) {
      //   console.log("v filtera sym", typeof value, search);
      return value != null && search != null && typeof value === "string" && value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1;
    },
    addDevices(technician) {
      this.editIndex = this.technicians.indexOf(technician);
      g_Dialog.show(
        g_Dialog.dialog_types.picker,
        this.devs.filter((d) => d.featureAccess || (d.duprofile && d.duprofile.cosmosableDevice)),
        {
          title: TR.AddDevicesTo + " " + technician.n,
          multiple: true,
          allowEmpty: true,
          toStringFn: function (i) {
            return i.Name + (i.Technician != null ? " (" + i.Technician.n + ")" : "");
          },
          selected: this.devs.filter((d) => d.TechnicianId == this.editIndex),
          buttonCancelText: TR.Cancel,
          buttonOKText: TR.Save,
        },
        (result) => {
          if (result != null) {
            this.devs.forEach((d) => {
              if (result.indexOf(d) != -1) {
                d.TechnicianId = this.editIndex;
              } else if (d.TechnicianId == this.editIndex) {
                d.TechnicianId = null;
              }
              if (TR.Locale != Translation.bg.Locale) {
                DataManager.updateDevNameAndSettingsGlobal(d.sn, d.devName, d.settings1, () => {
                  this.reload = true;
                  this.$nextTick(() => {
                    this.reload = false;
                  });
                });
              }
            });
            if (TR.Locale == Translation.bg.Locale) {
              DataManager.updateDevProfile(this.devs, () => {
                this.reload = true;
                this.$nextTick(() => {
                  this.reload = false;
                });
              });
            }
          }
        }
      );
    },
    editItem(technician) {
      this.editIndex = this.technicians.indexOf(technician);
      this.technician = Object.assign({}, technician);
      this.addTechnicianDialog = true;
    },
    deleteItem(item) {
      this.editIndex = this.technicians.indexOf(item);
      this.dialog.show(
        "yes-no",
        null,
        {
          title: TR.Confirmation,
          buttonNoText: TR.No,
          buttonYesText: TR.Yes,
          text: TR.ConfirmRemoveTechnician,
        },
        (result) => {
          if (result) {
            this.deleteTechnicianConfirm();
          } else {
            this.close();
          }
        }
      );
    },
    deleteTechnicianConfirm() {
      this.devs.forEach((d) => {
        if (d.Technician) {
          if (d.TechnicianId == this.editIndex) {
            d.TechnicianId = null;
          } else if (d.TechnicianId > this.editIndex) {
            d.TechnicianId = d.TechnicianId - 1;
          }
        }
      });
      this.technicians.splice(this.editIndex, 1);

      try {
        this.user.settings2.technicians.forEach((t) => {
          Object.keys(t).forEach((k) => !t[k] && delete t[k]);
        });
      } catch {
        /** ignored */
      }

      DataManager.updateUserSettings(null, this.user.settings2, null, null, null, (err) => {
        if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
          if (TR.Locale == TR.bg.Locale) {
            DataManager.updateDevProfile(this.devs, () => {
              this.dialogLoader.showInfo(TR.DeleteSuccessful);
            });
          } else {
            var f = 0;
            this.devs.forEach((d) => {
              DataManager.updateDevNameAndSettingsGlobal(d.sn, d.devName, d.settings1, () => {
                f++;
                if (f == this.devs.length) {
                  this.dialogLoader.showInfo(TR.DeleteSuccessful);
                }
              });
            });
          }
        } else {
          var msg = err.Message + "\n";
          if (err.ErrorDetails) {
            err.ErrorDetails.forEach((d) => (msg += d.Description + "\n"));
          }
          this.dialogLoader.showError(msg);
        }
      });
    },
    close() {
      this.addTechnicianDialog = false;
      this.$nextTick(() => {
        this.technician = Object.assign({}, this.defaultInfo);
        this.editIndex = -1;
      });
    },
    save() {
      if (!this.$refs.refValidationForm.validate()) {
        return;
      }
      if (this.editIndex > -1) {
        Object.assign(this.technicians[this.editIndex], this.technician);
      } else {
        this.technicians.push(this.technician);
      }
      var cbb = (err) => {
        if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
          this.close();
          this.dialogLoader.showInfo(this.editIndex > -1 ? TR.EditSuccessful : TR.AddSuccessful);
        } else {
          var msg = err.Message + "\n";
          if (err.ErrorDetails) {
            err.ErrorDetails.forEach((d) => (msg += d.Description + "\n"));
          }
          this.dialogLoader.showError(msg);
        }
      };

      try {
        this.user.settings2.technicians.forEach((t) => {
          Object.keys(t).forEach((k) => !t[k] && delete t[k]);
        });
      } catch {
        /** ignored */
      }
      DataManager.updateUserSettings(null, this.user.settings2, null, null, null, cbb);
    },
  },
  created() {
    window.addEventListener("resize", this.recalcGridHeight);
  },
  mounted() {
    // let pageOfText = this.$refs.techTR.grid.$el.querySelector(".v-data-footer__pagination");
    // if (pageOfText.innerHTML.includes("of")) pageOfText.innerHTML = pageOfText.innerHTML.replace("of", "от");
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcGridHeight);
  },
};
</script>

<style scoped></style>
